import { AlertAPI } from './types'

export const alertApi: AlertAPI = ky => {
  return {
    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/alert/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
